import React from "react";
import { useTranslation } from "react-i18next";

export default function HaGetRecommendations() {
  const { t } = useTranslation("help");

  const pythonCode = `import requests

API_KEY = ""  # ${t("HaGetRecommendations.required", "Required")}
SESSION_KEY = ""  # ${t("HaGetRecommendations.required", "Required")}
REPORT_ID = ""  # ${t("HaGetRecommendations.required", "Required")}
RECOMMENDATION_TYPE = "" # ${t("HaGetRecommendations.required", "Required")}; must be one of: full, rto, dos, mcp, reg

url = f"https://demo.whitehax.com/api/readiness-score/recommendations/?recomm_for={RECOMMENDATION_TYPE}&report_id={REPORT_ID}"

headers = {"Authorization": API_KEY, "X-Session-Key": SESSION_KEY}

response = requests.request("GET", url, headers=headers)

print(response.text)`;

  return (
    <div className="endpoint-container">
      <a href="#get-recommendations" className="endpoint-title">
        {t("HaGetRecommendations.title", "Get Recommendations")}
      </a>

      <pre className="code-block">
        <code>{pythonCode}</code>
      </pre>

      <style>{`
        .endpoint-container {
          width: 100%;
          box-sizing: border-box;
          background: #1f1f1f;
          color: #f5f5f5;
          padding: 20px;
          font-family: Arial, Helvetica, sans-serif;
        }

        .endpoint-title {
          display: inline-block;
          margin-bottom: 26px;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          text-decoration: underline;
          cursor: pointer;
        }

        .endpoint-title:hover {
          color: #b7ddf2;
        }

        .code-block {
          margin: 0;
          padding: 0;
          background: transparent;
          color: #d4d4d4;
          font-family: Consolas, "Courier New", monospace;
          font-size: 14px;
          line-height: 1.45;
          white-space: pre-wrap;
          overflow-x: auto;
          tab-size: 4;
        }

        .code-block code {
          font-family: inherit;
        }

        @media (max-width: 768px) {
          .endpoint-title {
            font-size: 15px;
            margin-bottom: 20px;
          }

          .code-block {
            font-size: 13px;
            line-height: 1.45;
          }
        }
      `}</style>
    </div>
  );
}